import { Link, useLocation } from "react-router-dom";
import {
  getSortedPosts,
  getPostHref,
  formatBlogDate,
  readMoreLabel,
} from "../../content/blogPosts";
import Seo from "../Seo";
import NewsletterForm from "../newsletter/NewsletterForm";
import styles from "./blog.module.css";

const UI = {
  tr: {
    title: "Blog",
    metaTitle:
      "Blog | Akaryakıt İstasyonu Yönetimi - Shift Tracker",
    subtitle:
      "Akaryakıt istasyonu yönetimi, vardiya mutabakatı ve nakit akışı üzerine yazılar.",
  },
  en: {
    title: "Blog",
    metaTitle:
      "Blog | Fuel Station Management - Shift Tracker",
    subtitle:
      "Articles on fuel station management, shift reconciliation and cash flow.",
  },
};

function BlogList(): JSX.Element {
  const location = useLocation();
  const isEnglish =
    location.pathname === "/en/blog" || location.pathname.startsWith("/en/");
  const lang: "tr" | "en" = isEnglish ? "en" : "tr";
  const ui = UI[lang];
  const posts = getSortedPosts();

  return (
    <div className={styles.page}>
      <Seo path="/blog" title={ui.metaTitle} description={ui.subtitle} />
      <div className={styles.container}>
        <header className={styles.header}>
          <h1>{ui.title}</h1>
          <p>{ui.subtitle}</p>
        </header>

        <div className={styles.grid}>
          {posts.map((post) => {
            const content = post[lang];
            const href = getPostHref(post, lang);
            return (
              <article key={post.slug} className={styles.card}>
                <time className={styles.date} dateTime={post.publishedAt}>
                  {formatBlogDate(post.publishedAt, lang)}
                </time>
                <h2 className={styles.cardTitle}>
                  <Link to={href}>{content.title}</Link>
                </h2>
                <p className={styles.excerpt}>{content.description}</p>
                <Link className={styles.readMore} to={href}>
                  {readMoreLabel[lang]} →
                </Link>
              </article>
            );
          })}
        </div>

        <NewsletterForm source="blog_list" />
      </div>
    </div>
  );
}

export default BlogList;
